import { Injectable } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

// import { retry, catchError } from 'rxjs/operators';
// import { throwError } from 'rxjs';
import { Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ListaGeocerca } from 'src/app/models/mapa-geocerca';
import { RutaCliente } from 'src/app/models/ruta-cliente';

@Injectable({
  providedIn: 'root'
})
export class ControlRutasService {

  public firstFiltroForm;
  private filtroForm = new Subject<any>();
  private rutasObs = new Subject<any>();
  private rutas = new Subject<any>();

  qs = require('qs');

  constructor(
    private gtp: Gtp,
    private http: HttpClient
  ) { }

  getFiltroForm(){
    return this.filtroForm.asObservable();
  }

  setFiltroForm(filtro){
    this.filtroForm.next(filtro);
  }

  callRutas() {
    this.getListaRutas().subscribe(res => {
      let lista = [];
      Object.entries(res).forEach(item => { lista.push(new RutaCliente(item[1]) ); });
      lista.sort(this.gtp.orderRutas);
      this.setRutas(lista);
    });
  }

  getRutas() {
    return this.rutasObs.asObservable();
  }

  setRutas(geo) {
    //this.rutas.next(geo);
    this.rutasObs.next(geo);
  }

  /**
   * Devuelve el listado de geocercas del usuario / cliente
   */
  getListaRutas(){    
    var filter = {    
      order: "nombre", 
    }
    let urlFilter = this.qs.stringify(filter);
    return this.http.get(`${environment.baseUrl}clientes/rutas/?`+urlFilter);
  }

  // getControlGeocercaMoviles(filtro){    
  //   var filter = {    
  //     order: "nombre",
  //     limit: filtro.pageSize,
  //     offset: filtro.pageIndex,
  //     historial: {   
  //       fecha_hora: {
  //         between: [filtro.desde, filtro.hasta]
  //       },
  //       velocidad: {
  //         gte: 10
  //       }
  //       //limit: (filtro.historialSize) ? filtro.historialSize : 0
  //     }
  //   };

  //   let codGeocerca = '';
  //   if (filtro.geocerca) {
  //     codGeocerca = filtro.geocerca;
  //   }

  //   if(filtro.buscar){
  //     filter['equipoRastreo'] = {  
  //       des_equipo_ratreo: {
  //         "iLike": `%${filtro.buscar}%`
  //       },
  //     };
  //   }

  //   let urlFilter = this.qs.stringify(filter);
  //   return this.http.get(`${environment.baseUrl}clientes/historial-geocercas/${codGeocerca}?`+urlFilter);

  // }

  // orderFilter(order){
  //   let orderCol = '';
  //   switch(order){
  //     case 'fecha':
  //     case 'hora':
  //       orderCol = 'fecha_hora';
  //       break;
  //     case 'geocerca':
  //       orderCol = 'cod_evento';
  //       break;
  //     default:
  //       orderCol = order;
  //   }
  //   return orderCol;
  // }  

}
